import { render, staticRenderFns } from "./PaymentSlipsShowComponent.vue?vue&type=template&id=10084bea&"
import script from "./PaymentSlipsShowComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentSlipsShowComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports